import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import './styles/theme.scss';
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./Authentication/authConfig.js";
// @ts-ignore
import AuthenticationLayer from "./Authentication/AuthenticationLayer.tsx";
import { UserDetailsProviderContext } from "./Contexts/UserProvider.tsx";
import { UIProvider } from "./Contexts/UIProvider.tsx";
import AppErrorBoundary from './ErrorBoundary/MainErrorBoundaryWrapper.tsx';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

export const msalInstance = new PublicClientApplication(msalConfig);

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById("root"));

const renderApp = () => {
  root.render(
    <AppErrorBoundary>
      <MsalProvider instance={msalInstance}>
        <UserDetailsProviderContext>
          <UIProvider>
            <QueryClientProvider client={queryClient}>
              <AuthenticationLayer />
            </QueryClientProvider>
          </UIProvider>
        </UserDetailsProviderContext>
      </MsalProvider>
    </AppErrorBoundary>
  );
};

msalInstance.addEventCallback((event) => {
  if (
    event.eventType === EventType.LOGIN_SUCCESS &&
    event.payload?.account
  ) {
    msalInstance.setActiveAccount(event.payload.account);
  }
});

msalInstance.initialize().then(() => {
  msalInstance
    .handleRedirectPromise()
    .then((response) => {
      if (response?.account) {
        msalInstance.setActiveAccount(response.account);
      } else {
        const cached = msalInstance.getAllAccounts();
        if (cached.length > 0) {
          msalInstance.setActiveAccount(cached[0]);
        }
      }
      sessionStorage.removeItem("msal_redirect_guard");
    })
    .catch((error) => {
      console.error("MSAL redirect error:", error);
    })
    .finally(() => {
      renderApp();
    });
});
